import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {},
    accordion: {
      border: '1px solid #D2D2D2',
      boxShadow: 'none',
      borderRadius: 5,
      padding: '8px',
      marginBottom: '8px',
      '&:last-child': {
        marginBottom: 0,
      },
      '& .MuiAccordionSummary-root': {
        minHeight: '20px',
        padding: '0 8px',
        '&.Mui-expanded': {
          minHeight: '20px',
        },
      },
    },
    accordionSummary: {
      '&.MuiAccordionSummary-root': {
        margin: 0,
        paddingRight: 0,
      },
      '& .MuiAccordionSummary-content': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: 0,
        padding: '8px 0',
        '&.Mui-expanded': {
          margin: 0,
          paddingBottom: '0',
        },

        '& > div': {
          display: 'flex',
          gap: '10px',
          alignItems: 'center',

          '& .MuiIconButton-root': {},
        },
      },
    },
    accordionDetails: {
      padding: '0',
    },
    areaInfo: {
      fontSize: '1.2rem',
      fontWeight: 600,
      fontFamily: theme.typography.body1.fontFamily,
    },
  }),
)
